import { type AdServerAdBannerDimensions } from '../../../ad-server'
import { type StoryblokAdBannerType } from '../../storyblok'

import { storyblokAdBannerParseDimensions } from './storyblokAdBannerParseDimensions'

export const storyblokAdBannerGetDimensionsByDevice = (
  blok: StoryblokAdBannerType,
  isMobile: boolean,
): AdServerAdBannerDimensions | undefined => {
  if (isMobile && blok.dimensionsMobile) {
    return storyblokAdBannerParseDimensions(blok.dimensionsMobile)
  }

  if (blok.dimensions) {
    return storyblokAdBannerParseDimensions(blok.dimensions)
  }

  return undefined
}
